import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Calendar } from "lucide-react";
import { api } from "@/lib/api";
import { useLanguage } from "@/i18n/LanguageContext";

const MobileBookCTA = () => {
  const { t } = useLanguage();
  const [phone, setPhone] = useState("");
  useEffect(() => {
    api.get("/site/contact").then((r) => setPhone(r.data.phone || "")).catch(() => {});
  }, []);
  return (
    <div
      data-testid="mobile-book-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-[#FAF6EC]/95 backdrop-blur-md border-t border-[#CFC4A8] p-3 flex items-center gap-2"
    >
      {phone && (
        <a
          data-testid="mobile-cta-call"
          href={`tel:${phone.replace(/\s/g, "")}`}
          className="flex-1 inline-flex items-center justify-center gap-2 border border-[#1E3B2E] text-[#1E3B2E] py-3 font-mono text-[10px] uppercase tracking-[0.32em]"
        >
          <Phone size={14} />
          {t("hero.cta_call")}
        </a>
      )}
      <Link
        data-testid="mobile-cta-book"
        to="/booking"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-[#1E3B2E] text-[#FAF6EC] py-3 font-mono text-[10px] uppercase tracking-[0.32em]"
      >
        <Calendar size={14} />
        {t("nav.book")}
      </Link>
    </div>
  );
};

export default MobileBookCTA;
